export default "__VITE_ASSET__5a04cb02__"